import React, { useEffect, useState,useMemo } from "react";
import { useParams } from "react-router-dom";
import axios from "../../../axios";
import dayjs from "dayjs";

import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import Cell from "../../../componant/Table/cell";
import Table from "../../../componant/Table/Table";

function ViewUser() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [contestHistory, setContestHistory] = useState([]);
  const [withdrawalHistory, setWithdrawalHistory] = useState([]);
  const [coinTransactions, setCoinTransactions] = useState([]);
  const [kycDetails, setKycDetails] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [withdrawals, setWithdrawals] = useState([]);

  
  useEffect(() => {
    fetchUser();
    fetchKycDetails();
    fetchHistory();
    fetchWithdrawalHistory();
    fetchCoinTransactions();
  }, []);
  const withdrawColumns = React.useMemo(
  () => [
    {
      Header: "Amount",
      accessor: "amount",
      Cell: ({ value }) => <Cell text={`₹ ${value}`} />,
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <Cell text={value.toUpperCase()} />
      ),
    },
    {
      Header: "Mode",
      accessor: "mode",
      Cell: ({ value }) => <Cell text={value} />,
    },
    {
      Header: "Bank",
      accessor: "bankName",
      Cell: ({ value }) => <Cell text={value} />,
    },
    {
      Header: "Account No",
      accessor: "accountNo",
      Cell: ({ value }) => <Cell text={value} />,
    },
    {
      Header: "Created On",
      accessor: "createdOn",
      Cell: ({ value }) => (
        <Cell
          text={dayjs(value).format("DD MMM YYYY hh:mm A")}
        />
      ),
    },
    {
      Header: "Payment Done",
      accessor: "paymentDoneOn",
      Cell: ({ value }) => (
        <Cell
          text={
            value
              ? dayjs(value).format("DD MMM YYYY hh:mm A")
              : "-"
          }
        />
      ),
    },
    {
  Header: "Deducted Coins",
  accessor: "deductedCoins",
  Cell: ({ row: { original } }) => (
    <div className="rounded bg-gray-100 p-2 text-sm min-w-[180px]">
      <p>Contest : {original?.deductedFrom?.contestCoins ?? 0}</p>
      <p>Referral : {original?.deductedFrom?.referralCoins ?? 0}</p>
      <p>Question : {original?.deductedFrom?.questionCoins ?? 0}</p>
    </div>
  ),
},
  ],
  []
);

  const fetchUser = async () => {
    try {
      const res = await axios.get(`getSingleUserDetail/${id}`);
      setUser(res?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchKycDetails = async () => {
    try {
      const res = await axios.get(`getOneKycUsers/${id}`);
      setKycDetails(res?.data?.result || null);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchHistory = async () => {
    try {
      const res = await axios.get(`/contest/history/${id}`);
      setContestHistory(res?.data?.result?.history || []);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchWithdrawalHistory = async () => {
    try {
      const res = await axios.get(`/withdrawal-details?userId=${id}`);

         setWithdrawals(res.data.result.allRequests || []);
      setWithdrawalHistory(res?.data?.result || []);
    } catch (error) {
      console.log(error);
    }
  };
 
  const fetchCoinTransactions = async () => {
    try {
      const res = await axios.get(`/user-transactions?userId=${id}`);
      setCoinTransactions(res?.data?.result || []);
    } catch (error) {
      console.log(error);
    }
  };

  if (!user) {
    return <div className="p-10 text-center">Loading...</div>;
  }

  const isDebit = (type) => {
  return type === "spent_contest" || type === "wallet_debit";
};
  const getTransactionTitle = (type) => {
  switch (type) {
    case "spent_contest":
      return "Contest Entry";
    case "contest_reward":
      return "Contest Reward";
    case "wallet_debit":
      return "Wallet Debit";
    default:
      return type;
  }
};


  return (
    <div className="min-h-screen w-full min-w-0 bg-gray-100 p-3 sm:p-5 lg:p-8 [&_p]:[overflow-wrap:anywhere]">

      <div className="w-full min-w-0 rounded-xl bg-white p-3 shadow-lg sm:p-5 lg:p-6">

        <h2 className="mb-4 text-xl font-bold text-purple sm:mb-6 sm:text-2xl">
          User Profile
        </h2>

        <Tabs variant="enclosed" minW={0}>

          <TabList overflowX="auto" overflowY="hidden" sx={{ "& > button": { flexShrink: 0, whiteSpace: "nowrap" } }} fontSize={{ base: "sm", md: "md" }}>
            <Tab>User Details</Tab>
            <Tab>Contest Details</Tab>
            <Tab>Coin Transactions</Tab> 
             <Tab>Withdrawal History</Tab>
          </TabList>

          <TabPanels minW={0} sx={{ "& > [role=tabpanel]": { padding: { base: "16px 0", md: "20px 0" }, minWidth: 0 } }}>

            {/* ---------------- USER DETAILS TAB ---------------- */}

         <TabPanel>

<div className="grid grid-cols-1 gap-4 xl:grid-cols-3 xl:gap-6 [&>div]:min-w-0">

{/* Profile Card */}

<div className="rounded-xl bg-white p-4 text-center shadow sm:p-6">

<button
  type="button"
  onClick={() =>
    setSelectedImage(
      user.profilePicUrl ||
        user.profileImage ||
        "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
    )
  }
  className="mx-auto mb-3 block rounded-full focus:outline-none focus:ring-2 focus:ring-purple"
>
  <img
    src={
      user.profilePicUrl ||
      user.profileImage ||
      "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
    }
    alt={user.name || "User profile"}
    className="w-24 h-24 rounded-full object-cover"
  />
</button>

<h2 className="text-xl font-bold">{user.name}</h2>
<p className="text-gray-500">{user.email}</p>
<p className="text-gray-500">{user.mobile}</p>

<span className={`mt-3 inline-block px-3 py-1 rounded-full text-sm
${user.mobileVerified ? "bg-green-100 text-green-600" : "bg-red-100 text-red-500"}`}>
{user.mobileVerified ? "Verified" : "Not Verified"}
</span>

</div>

{/* Basic Info */}

<div className="rounded-xl bg-white p-4 shadow sm:p-6 xl:col-span-2">

<h3 className="font-bold text-lg mb-4">Basic Information</h3>

<div className="grid grid-cols-1 gap-4 text-sm sm:grid-cols-2 [&>div]:min-w-0">

<div>
<span className="text-gray-500">User ID</span>
<p className="font-semibold">{user._id}</p>
</div>

<div>
<span className="text-gray-500">Plan</span>
<p className="font-semibold">{user.planName}</p>
</div>

<div>
<span className="text-gray-500">Gender</span>
<p className="font-semibold">{user.gender}</p>
</div>

<div>
<span className="text-gray-500">Qualification</span>
<p className="font-semibold">{user.qualification}</p>
</div>

<div>
<span className="text-gray-500">State</span>
<p className="font-semibold">{user.userState}</p>
</div>

<div>
<span className="text-gray-500">Platform</span>
<p className="font-semibold">{user.platform}</p>
</div>

<div>
<span className="text-gray-500">Created On</span>
<p className="font-semibold">
{dayjs(user.createdOn).format("DD MMM YYYY")}
</p>
</div>

</div>

</div>

</div>


{/* Wallet Section */}

<div className="mt-4 rounded-xl bg-white p-4 shadow sm:mt-6 sm:p-6">

<h3 className="font-bold text-lg mb-4">Wallet Details</h3>

<div className="grid grid-cols-1 gap-4 text-sm sm:grid-cols-2 xl:grid-cols-4 [&>div]:min-w-0">

<div>
<span className="text-gray-500">Total Balance</span>
<p className="font-semibold">{user.unifiedWallet.balance}</p>
</div>

<div>
<span className="text-gray-500">Contest Balance</span>
<p className="font-semibold">{user.unifiedWallet.contestBalance}</p>
</div>

<div>
<span className="text-gray-500">Recharge Balance</span>
<p className="font-semibold">{user.unifiedWallet.rechargedBalance}</p>
</div>

<div>
<span className="text-gray-500">Locked Balance</span>
<p className="font-semibold">{user.unifiedWallet.lockedBalance}</p>
</div>

</div>

</div>


{/* KYC Section */}

<div className="mt-4 rounded-xl bg-white p-4 shadow sm:mt-6 sm:p-6">

<h3 className="font-bold text-lg mb-4">KYC Details</h3>

{kycDetails ? (
  <>
    <div className="grid grid-cols-1 gap-4 text-sm sm:grid-cols-2 xl:grid-cols-4 [&>div]:min-w-0">
      <div>
        <span className="text-gray-500">Holder Name</span>
        <p className="font-semibold">{kycDetails.holderName || "-"}</p>
      </div>

      <div>
        <span className="text-gray-500">Bank Name</span>
        <p className="font-semibold">{kycDetails.bankName || "-"}</p>
      </div>

      <div>
        <span className="text-gray-500">Account No</span>
        <p className="font-semibold">{kycDetails.accountNo || "-"}</p>
      </div>

      <div>
        <span className="text-gray-500">IFSC</span>
        <p className="font-semibold">{kycDetails.ifsc || "-"}</p>
      </div>

      <div>
        <span className="text-gray-500">Aadhar</span>
        <p className="font-semibold">{kycDetails.aadharNo || "-"}</p>
      </div>

      <div>
        <span className="text-gray-500">UPI</span>
        <p className="font-semibold">{kycDetails.upiId || "-"}</p>
      </div>

      <div>
        <span className="text-gray-500">Status</span>
        <p className="font-semibold capitalize">{kycDetails.status || "-"}</p>
      </div>

      <div>
        <span className="text-gray-500">Created On</span>
        <p className="font-semibold">
          {kycDetails.createdOn
            ? dayjs(kycDetails.createdOn).format("DD MMM YYYY")
            : "-"}
        </p>
      </div>
    </div>

    <div className="mt-5 grid gap-4 sm:grid-cols-2">
      {kycDetails.documentFrontImage && (
        <div>
          <p className="mb-2 text-sm font-semibold text-gray-600">
            Document Front
          </p>
          <button
            type="button"
            onClick={() => setSelectedImage(kycDetails.documentFrontImage)}
            className="block w-full max-w-sm focus:outline-none focus:ring-2 focus:ring-purple"
          >
            <img
              src={kycDetails.documentFrontImage}
              alt="Document front"
              className="h-44 w-full max-w-sm cursor-pointer rounded-lg border object-cover"
            />
          </button>
        </div>
      )}

      {kycDetails.documentBackImage && (
        <div>
          <p className="mb-2 text-sm font-semibold text-gray-600">
            Document Back
          </p>
          <button
            type="button"
            onClick={() => setSelectedImage(kycDetails.documentBackImage)}
            className="block w-full max-w-sm focus:outline-none focus:ring-2 focus:ring-purple"
          >
            <img
              src={kycDetails.documentBackImage}
              alt="Document back"
              className="h-44 w-full max-w-sm cursor-pointer rounded-lg border object-cover"
            />
          </button>
        </div>
      )}
    </div>
  </>
) : (
  <p className="text-sm text-gray-500">No KYC details found.</p>
)}

</div>


{/*Withdrawal Section */}

<div className="mt-4 rounded-xl bg-white p-4 shadow sm:mt-6 sm:p-6">

  <h3 className="font-bold text-lg mb-4">Withdrawal Details</h3>

  <div className="grid grid-cols-1 gap-4 text-sm sm:grid-cols-2 xl:grid-cols-3 [&>div]:min-w-0">

    {/* ✅ Total Withdraw */}
    <div>
      <span className="text-gray-500">Total Withdraw Amount</span>
      <p className="font-semibold">
        {withdrawalHistory?.wholeAmount || 0}
      </p>
    </div>

    {/* ✅ Last Submitted */}
    <div>
      <span className="text-gray-500">Last Withdrawal Date</span>
      <p className="font-semibold">
        {withdrawalHistory?.allRequests?.length > 0
          ? dayjs(withdrawalHistory.allRequests[0].createdOn).format("DD MMM YYYY")
          : "-"}
      </p>
    </div>

    {/* ✅ Payment Done On */}
    <div>
      <span className="text-gray-500">Payment Done On</span>
      <p className="font-semibold">
        {withdrawalHistory?.allRequests?.length > 0
          ? dayjs(withdrawalHistory.allRequests[0].paymentDoneOn).format("DD MMM YYYY")
          : "-"}
      </p>
    </div>
 
    <div>
  <span className="text-gray-500">Deducted From</span>

  <div className="font-semibold mt-1 space-y-1">
    {withdrawalHistory?.allRequests?.length > 0 && (
      <>
        {withdrawalHistory.allRequests[0].deductedFrom.contestCoins > 0 && (
          <p className="text-purple-600">
            Contest Coins: {withdrawalHistory.allRequests[0].deductedFrom.contestCoins}
          </p>
        )}

        {withdrawalHistory.allRequests[0].deductedFrom.referralCoins > 0 && (
          <p className="text-blue-600">
            Referral Coins: {withdrawalHistory.allRequests[0].deductedFrom.referralCoins}
          </p>
        )}

        {withdrawalHistory.allRequests[0].deductedFrom.questionCoins > 0 && (
          <p className="text-green-600">
            Question Coins: {withdrawalHistory.allRequests[0].deductedFrom.questionCoins}
          </p>
        )}
      </>
    )}
  </div>
</div>
  </div>

</div>


{/* Quiz Stats */}

<div className="mt-4 rounded-xl bg-white p-4 shadow sm:mt-6 sm:p-6">

<h3 className="font-bold text-lg mb-4">Quiz Statistics</h3>

<div className="grid grid-cols-1 gap-4 text-sm sm:grid-cols-2 xl:grid-cols-4 [&>div]:min-w-0">

<div>
<span className="text-gray-500">Right</span>
<p className="font-semibold">{user.quizStats.totalRight}</p>
</div>

<div>
<span className="text-gray-500">Wrong</span>
<p className="font-semibold">{user.quizStats.totalWrong}</p>
</div>

<div>
<span className="text-gray-500">Skipped</span>
<p className="font-semibold">{user.quizStats.totalSkipped}</p>
</div>

<div>
<span className="text-gray-500">Question Time</span>
<p className="font-semibold">{user.quizStats.questionTime}s</p>
</div>

</div>

</div>


{/* Device Info */}

<div className="mt-4 rounded-xl bg-white p-4 shadow sm:mt-6 sm:p-6">

<h3 className="font-bold text-lg mb-4">Current Device</h3>

<div className="grid grid-cols-1 gap-4 text-sm sm:grid-cols-2 xl:grid-cols-3 [&>div]:min-w-0">

<div>
<span className="text-gray-500">Device Name</span>
<p className="font-semibold">{user.currentDevice.deviceName}</p>
</div>

<div>
<span className="text-gray-500">Device Type</span>
<p className="font-semibold">{user.currentDevice.deviceType}</p>
</div>

<div>
<span className="text-gray-500">Device ID</span>
<p className="font-semibold">{user.currentDevice.deviceId}</p>
</div>

</div>

</div>

</TabPanel>

            {/* ---------------- CONTEST HISTORY TAB ---------------- */}

         <TabPanel>
  {contestHistory.length === 0 ? (
    <p>No Contest Found</p>
  ) : (
    <div className="hidden w-full min-w-0 overflow-x-auto lg:block">
      <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
        
        <thead className="bg-purple text-white">
          <tr>
            <th className="px-4 py-2 text-left">Sr No</th>
            <th className="px-4 py-2 text-left">Contest</th>
            <th className="px-4 py-2 text-left">Date</th>
            <th className="px-4 py-2 text-left">Entry Coins</th>
            <th className="px-4 py-2 text-left">Earn Coins</th>
            <th className="px-4 py-2 text-left">Prize Coins</th>
            <th className="px-4 py-2 text-left">Rank</th>
            <th className="px-4 py-2 text-left">Status</th>
          </tr>
        </thead>

        <tbody>
          {contestHistory.map((item, index) => (
            <tr
              key={index}
              className="border-b hover:bg-gray-50 transition"
            >
              <td className="px-4 py-2">{index + 1}</td>

              <td className="px-4 py-2 font-semibold text-purple">
                {item.title}
              </td>

              <td className="px-4 py-2">
                {dayjs(item.date).format("DD MMM YYYY")}
              </td>

              <td className="px-4 py-2">{item.entry}</td>

              <td className="px-4 py-2">{item.coins}</td>

              <td className="px-4 py-2">{item.prize}</td>

              <td className="px-4 py-2">{item.rank}</td>

              <td className="px-4 py-2">
                <span
                  className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    item.status === "Won"
                      ? "bg-green-100 text-green-600"
                      : item.status === "Pending"
                      ? "bg-yellow-100 text-yellow-600"
                      : "bg-red-100 text-red-500"
                  }`}
                >
                  {item.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>

      </table>
    </div>
  )}
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:hidden [&>div]:min-w-0">
  {contestHistory?.length > 0 ? (
    contestHistory.map((item, index) => (
      <div
        key={item._id}
        className="bg-white rounded-xl shadow border p-4"
      >
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h3 className="font-bold text-orange-500">
            #{index + 1}
          </h3>

          <span className="text-xs text-gray-500">
            {dayjs(item.date).format("DD MMM YYYY")}
          </span>
        </div>

        <div className="mt-3 space-y-2 text-sm">
          <p>
            <span className="font-semibold">Contest :</span>{" "}
            {item?.title}
          </p>

          <p>
            <span className="font-semibold">Entry Coin :</span>{" "}
            {item?.entry}
          </p>

          <p>
            <span className="font-semibold">Prize :</span>{" "}
            ₹ {item?.prize}
          </p>

          <p>
            <span className="font-semibold">Status :</span>{" "}
            {item?.status}
          </p>

          <p>
            <span className="font-semibold">Rank :</span>{" "}
            {item?.rank}
          </p>

          <p>
            <span className="font-semibold">Earned Coins :</span>{" "}
            {item?.coins}
          </p>
        </div>
      </div>
    ))
  ) : (
    <div className="text-center py-8">
      No Contest Found
    </div>
  )}
</div>
</TabPanel>


{/* ---------------- COIN HISTORY TAB ---------------- */}
<TabPanel>
  {coinTransactions?.transactions?.length === 0 ? (
    <p>No Transactions Found</p>
  ) : (
    <div className="hidden w-full min-w-0 overflow-x-auto lg:block">
      <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">

        <thead className="bg-purple text-white">
          <tr>
            <th className="px-4 py-2 text-left">Sr No</th>
            <th className="px-4 py-2 text-left">Type</th>
            <th className="px-4 py-2 text-left">Amount</th>
            <th className="px-4 py-2 text-left">Before Balance</th>
            <th className="px-4 py-2 text-left">After Balance</th>
            <th className="px-4 py-2 text-left">Description</th>
            <th className="px-4 py-2 text-left">Date</th>
          </tr>
        </thead>

        <tbody>
          {coinTransactions?.transactions?.map((item, index) => (
            <tr key={index} className="border-b hover:bg-gray-50">

              <td className="px-4 py-2">{index + 1}</td>

 <td className="px-4 py-2">
  <span
    className={`px-2 py-1 rounded text-xs font-semibold ${
      isDebit(item.type)
        ? "bg-red-100 text-red-500"
        : "bg-green-100 text-green-600"
    }`}
  >
    {getTransactionTitle(item.type)}
  </span>
</td>

              <td
  className={`px-4 py-2 font-bold ${
    isDebit(item.type) ? "text-red-500" : "text-green-600"
  }`}
>
  {isDebit(item.type) ? "-" : "+"}
  {item.amount}
</td>

              <td className="px-4 py-2">
                {item.balanceBefore}
              </td>
              <td className="px-4 py-2">
                {item.balanceAfter}
              </td>

              <td className="px-4 py-2">
                {item.description || "-"}
              </td>

              <td className="px-4 py-2">
                {dayjs(item.createdOn).format("DD MMM YYYY, hh:mm A")}
              </td>

            </tr>
          ))}
        </tbody>

      </table>
    </div>
  )}
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:hidden [&>div]:min-w-0">
  {coinTransactions?.transactions?.length > 0 ? (
    coinTransactions.transactions.map((item, index) => (
      <div
        key={item._id}
        className="bg-white rounded-xl shadow border p-4"
      >
        <div className="flex flex-wrap justify-between gap-2">
          <h3 className="font-bold text-orange-500">
            #{index + 1}
          </h3>

          <span
            className={`px-2 py-1 rounded text-xs ${
              item.type === "credit"
                ? "bg-green-100 text-green-600"
                : "bg-red-100 text-red-600"
            }`}
          >
            {item.type}
          </span>
        </div>

        <div className="space-y-2 mt-3 text-sm">
          <p>
            <span className="font-semibold">
              Coins :
            </span>{" "}
            {item.amount}
          </p>

          <p>
            <span className="font-semibold">
              Before Balance :
            </span>{" "}
            {item.balanceBefore}
          </p>

          <p>
            <span className="font-semibold">
              After Balance :
            </span>{" "}
            {item.balanceAfter}
          </p>

          <p>
            <span className="font-semibold">
              Date :
            </span>{" "}
            {dayjs(item.createdOn).format(
              "DD MMM YYYY hh:mm A"
            )}
          </p>
        </div>
      </div>
    ))
  ) : (
    <div className="text-center py-8">
      No Transactions Found
    </div>
  )}
</div>
</TabPanel>
{/* ---------------- WITHDRAWAL HISTORY TAB ---------------- */}
  <TabPanel>

      {/* Desktop */}

      <div className="hidden w-full min-w-0 overflow-x-auto lg:block">
        <Table
          data={withdrawals}
          columns={withdrawColumns}
        />
      </div>

      {/* Mobile */}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:hidden [&>div]:min-w-0">
        {withdrawals.map((item) => (
          <div
            key={item._id}
            className="rounded-xl border bg-white p-4 shadow"
          >
            <div className="flex flex-wrap justify-between gap-2">
              <h2 className="font-bold text-lg">
                ₹ {item.amount}
              </h2>

              <span
                className={`px-3 py-1 rounded-full text-xs font-semibold ${
                  item.status === "success"
                    ? "bg-green-100 text-green-700"
                    : item.status === "pending"
                    ? "bg-yellow-100 text-yellow-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {item.status}
              </span>
            </div>

            <div className="mt-3 space-y-2 text-sm">

              <p>
                <b>Name:</b> {item.name}
              </p>

              <p>
                <b>Mobile:</b> {item.mobile}
              </p>

              <p>
                <b>Bank:</b> {item.bankName}
              </p>

              <p>
                <b>Account:</b> {item.accountNo}
              </p>

              <p>
                <b>IFSC:</b> {item.ifsc}
              </p>

              <p>
                <b>Mode:</b> {item.mode}
              </p>

              <p>
                <b>Created:</b>{" "}
                {dayjs(item.createdOn).format(
                  "DD MMM YYYY hh:mm A"
                )}
              </p>

              {item.paymentDoneOn && (
                <p>
                  <b>Paid On:</b>{" "}
                  {dayjs(item.paymentDoneOn).format(
                    "DD MMM YYYY hh:mm A"
                  )}
                </p>
              )}

              <div className="rounded bg-gray-100 p-2 mt-2">
                <p className="font-semibold mb-1">
                  Deducted Coins
                </p>

                <p>
                  Contest : {item.deductedFrom.contestCoins}
                </p>

                <p>
                  Referral : {item.deductedFrom.referralCoins}
                </p>

                <p>
                  Question : {item.deductedFrom.questionCoins}
                </p>
              </div>
            </div>
          </div>
        ))}

        {withdrawals.length === 0 && (
          <div className="text-center py-10 text-gray-500">
            No Withdrawal History Found
          </div>
        )}
      </div>

    
</TabPanel>
</TabPanels>
        </Tabs>

      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-opacity-75 p-4 sm:p-6"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative min-w-0 max-h-full max-w-4xl">
            <button
              type="button"
              onClick={() => setSelectedImage(null)}
              className="absolute -right-2 -top-2 rounded-full bg-white px-3 py-1 text-lg font-bold text-gray-800 shadow"
            >
              x
            </button>
            <img
              src={selectedImage}
              alt="Preview"
              className="max-h-[85vh] max-w-full rounded-lg bg-white object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}

    </div>
  );
}

export default ViewUser;
